import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { Section } from "./SectionBlock";
import { defaultData } from "./SectionBlockDefaultData";
import { meta } from "./SectionBlockMetaData";

export const SectionBlock: BlockExport = {
  type: "component",
  Block: Section,
  imagePreview: {
    type: "icon",
    name: "24-builder-element-section",
    size: 24,
  },
  defaultData,
  meta,
};
